import { createSlice } from '@reduxjs/toolkit';
import { getUnavailableDates } from './actions';

const initialState = {
  data: [],
  isLoading: false,
  isError: false,
  errorMessage: '', // kalo retry setelah error, harus hapus errorMessage dan isError!
};

export const unavailableDates = createSlice({
  name: 'unavailableDates',
  initialState,
  reducers: {
    // reducers goes here
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUnavailableDates.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = '';
      })
      .addCase(getUnavailableDates.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
        state.data = [];
      })
      .addCase(getUnavailableDates.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      });
  },
});

export default unavailableDates.reducer;
